import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Clock, User } from 'lucide-react'
import type { HistorialReporte, HistorialReporteWhatsApp } from '../types'

interface HistorialTimelineProps {
  historial: HistorialReporte[] | HistorialReporteWhatsApp[]
  tipo: 'email' | 'whatsapp'
}

function formatNum(n: number) {
  return new Intl.NumberFormat('es-EC').format(n)
}

export function HistorialTimeline({ historial, tipo }: HistorialTimelineProps) {
  if (historial.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No hay historial de ediciones
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {historial.map((entry, index) => (
        <Card key={entry.id} className="border border-gray-300 dark:border-gray-700">
          <CardHeader className="pb-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="gap-1 text-xs">
                  <Clock className="h-3 w-3" />
                  {new Date(entry.fecha_snapshot).toLocaleDateString('es-EC', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </Badge>
                {entry.usuario_nombre && (
                  <Badge variant="secondary" className="gap-1 text-xs">
                    <User className="h-3 w-3" />
                    {entry.usuario_nombre}
                  </Badge>
                )}
              </div>
              <span className="text-xs text-muted-foreground">
                Edicion #{historial.length - index}
              </span>
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
              <MetricItem label="Base" value={formatNum(entry.base)} />
              <MetricItem label="Entrega" value={formatNum(entry.entrega)} />
              {tipo === 'email' ? (
                <>
                  <MetricItem
                    label="Aperturas"
                    value={formatNum((entry as HistorialReporte).aperturas_unicas)}
                  />
                  <MetricItem
                    label="Clics"
                    value={formatNum((entry as HistorialReporte).clics_unicos)}
                  />
                </>
              ) : (
                <>
                  <MetricItem
                    label="Leidos"
                    value={formatNum((entry as HistorialReporteWhatsApp).leidos)}
                  />
                  <MetricItem
                    label="Clics"
                    value={formatNum((entry as HistorialReporteWhatsApp).clics)}
                  />
                </>
              )}
              <MetricItem label="Unsub" value={formatNum(entry.unsub)} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

function MetricItem({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-[10px] text-muted-foreground uppercase">{label}</p>
      <p className="text-sm font-semibold">{value}</p>
    </div>
  )
}
